export const apiPath = "https://www.vrachtscan.nl/api/v1";
// export const apiPath = "http://192.168.178.15:3001/api/v1";
// export const apiPath = "http://10.255.39.107:3001/api/v1";
// export const apiPath = "http://localhost:3001/api/v1";

// export const apiPathv2 = "http://localhost:3000/api/v1";
export const apiPathv2 = "https://freightscan.nl/api/v1";
